import React, { AnchorHTMLAttributes, FC, PropsWithChildren, ReactElement } from 'react';

interface IProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  title: string;
  iconLeft?: ReactElement;
  iconRight?: ReactElement;
}

const IconWrapper: FC<PropsWithChildren<unknown>> = ({ children }) => (
  <span className="icon inline-flex items-center text-primary">{children}</span>
);

export default function NavigationAnchor({
  iconLeft,
  iconRight,
  children,
  className,
  ...aProps
}: PropsWithChildren<IProps>) {
  return (
    <a
      {...aProps}
      className={`inline-flex flex-auto items-center gap-2 font-medium text-sm p-4 hover:text-primary focus:text-primary ${className}`}>
      {iconLeft && <IconWrapper>{iconLeft}</IconWrapper>}
      {children}
      {iconRight && <IconWrapper>{iconRight}</IconWrapper>}
    </a>
  );
}
